export enum ReferralStatus {
  PENDING = "PENDING",
  QUALIFIED = "QUALIFIED",
  BLOCKED = "BLOCKED",
}
